export const UPLOAD_PAPER_REQUEST = 'UPLOAD_PAPER_REQUEST';
export const UPLOAD_PAPER_SUCCESS = 'UPLOAD_PAPER_SUCCESS';
export const UPLOAD_PAPER_FAILURE = 'UPLOAD_PAPER_FAILURE';

export const UPDATE_PAPER_INPUT  = 'UPDATE_PAPER_INPUT';
export const UPDATE_TAB          = 'UPDATE_TAB';
export const CANCEL_PAPER_UPLOAD = 'CANCEL_PAPER_UPLOAD';
export const GET_PAPER           = 'GET_PAPER';
export const GET_PRICING_REQUEST = 'GET_PRICING_REQUEST';
export const GET_PRICING_SUCCESS = 'GET_PRICING_SUCCESS';
export const GET_PRICING_FAILURE = 'GET_PRICING_FAILURE';
export const CLEAR_PAPER_SESSION = 'CLEAR_PAPER_SESSION';

export const UPDATE_AFFILIATE_NAME = 'UPDATE_AFFILIATE_NAME';
export const UPDATE_AFFILIATE_AMOUNT = 'UPDATE_AFFILIATE_AMOUNT';

export const UPDATE_COUPON_PROP = 'UPDATE_COUPON_PROP';

export const CHECK_COUPON_REQUEST       = 'CHECK_COUPON_REQUEST';
export const CHECK_COUPON_SUCCESS       = 'CHECK_COUPON_SUCCESS';
export const CHECK_COUPON_FAILURE       = 'CHECK_COUPON_FAILURE';
export const UPDATE_COUPON_CODE         = 'UPDATE_COUPON_CODE';

export const UPDATE_BALANCE_USED            = 'UPDATE_BALANCE_USED';
export const UPDATE_BALANCE_USED_SUCCESS    = 'UPDATE_BALANCE_USED_SUCCESS';
export const UPDATE_BALANCE_USED_FAILURE    = 'UPDATE_BALANCE_USED_FAILURE';

export const UPDATE_STEP_2              = 'UPDATE_STEP_2';
export const UPDATE_STEP_3              = 'UPDATE_STEP_3';
export const UPDATE_STEP_3_SPECIAL_TEXT = 'UPDATE_STEP_3_SPECIAL_TEXT';
export const UPDATE_STEP_3_UPLOAD               = 'UPDATE_STEP_3_UPLOAD';
export const UPLOAD_SPECIAL_INSTUCTIONS_REQUEST = 'UPLOAD_SPECIAL_INSTUCTIONS_REQUEST';
export const UPLOAD_SPECIAL_INSTUCTIONS_FAILURE = 'UPLOAD_SPECIAL_INSTUCTIONS_FAILURE';
export const UPLOAD_SPECIAL_INSTUCTIONS_SUCCESS = 'UPLOAD_SPECIAL_INSTUCTIONS_SUCCESS';
export const UPDATE_EXTRAS_DIFFERENCE = 'UPDATE_EXTRAS_DIFFERENCE';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const CLOSE_ALL_MODALS           = 'CLOSE_ALL_MODALS';
export const OPEN_EXTRAS_MODAL  = 'OPEN_EXTRAS_MODAL';
export const CLOSE_EXTRAS_MODAL = 'CLOSE_EXTRAS_MODAL';
export const REMOVE_EXTRA       = 'REMOVE_EXTRA';
export const UPSELL_EDITOR_LEVEL = 'UPSELL_EDITOR_LEVEL';
export const UPSELL_TIME_LIMIT  = 'UPSELL_TIME_LIMIT';
export const VALIDATE_EMAIL     = 'VALIDATE_EMAIL';
export const INVALIDATE_EMAIL   = 'INVALIDATE_EMAIL';
export const BOTH_EMAILS_MATCH  = 'BOTH_EMAILS_MATCH';
export const BOTH_EMAILS_DONT_MATCH = 'BOTH_EMAILS_DONT_MATCH';
export const TERMS_CHECKED      = 'TERMS_CHECKED';
export const TOGGLE_QUESTION    = 'TOGGLE_QUESTION';
export const OPEN_QUESTION      = 'OPEN_QUESTION';
export const CLOSE_QUESTION     = 'CLOSE_QUESTION';
export const OPEN_TERMS_MODAL   = 'OPEN_TERMS_MODAL';
export const CLOSE_TERMS_MODAL  = 'CLOSE_TERMS_MODAL';
export const OPEN_BRONZE_EXAMPLE_MODAL = 'OPEN_BRONZE_EXAMPLE_MODAL';
export const OPEN_SILVER_EXAMPLE_MODAL = 'OPEN_SILVER_EXAMPLE_MODAL';
export const CLOSE_CITATION_MENU = 'CLOSE_CITATION_MENU';
export const OPEN_CITATION_MENU = 'OPEN_CITATION_MENU';
export const CLOSE_BRONZE_EXAMPLE_MODAL = 'CLOSE_BRONZE_EXAMPLE_MODAL';
export const OPEN_GOLD_EXAMPLE_MODAL = 'OPEN_GOLD_EXAMPLE_MODAL';
export const CLOSE_GOLD_EXAMPLE_MODAL = 'CLOSE_GOLD_EXAMPLE_MODAL';
export const CLOSE_SILVER_EXAMPLE_MODAL = 'CLOSE_SILVER_EXAMPLE_MODAL';
export const CLOSE_FAQ_MODAL    = 'CLOSE_FAQ_MODAL';
export const OPEN_FAQ_MODAL     = 'OPEN_FAQ_MODAL';
export const DOWNSELL_TIME_LIMIT = 'DOWNSELL_TIME_LIMIT';
export const DOWNSELL_EDITOR_LEVEL = 'DOWNSELL_EDITOR_LEVEL';
export const REGISTER_STUDENT_SUCCESS = 'REGISTER_STUDENT_SUCCESS';
export const REGISTER_STUDENT_FAILURE = 'REGISTER_STUDENT_FAILURE';
export const REGISTER_STUDENT_REQUEST = 'REGISTER_STUDENT_REQUEST';
export const LOGIN_STUDENT_REQUEST = 'LOGIN_STUDENT_REQUEST';
export const LOGIN_STUDENT_FAILURE = 'LOGIN_STUDENT_FAILURE';
export const LOGIN_STUDENT_SUCCESS = 'LOGIN_STUDENT_SUCCESS';
export const CHECK_EXISTING_USER = 'CHECK_EXISTING_USER';

export const GET_STUDENT_SUBMISSIONS_SUCCESS = 'GET_STUDENT_SUBMISSIONS_SUCCESS';
export const GET_STUDSUBMISSIONINEDIT_SUCCESS = 'GET_STUDSUBMISSIONINEDIT_SUCCESS';
export const GET_STUDSUBMISSIONCOMPLETE_SUCCESS = 'GET_STUDSUBMISSIONCOMPLETE_SUCCESS';
export const GET_DOCUMENT_DETAILS_SUCCESS = 'GET_DOCUMENT_DETAILS_SUCCESS';
export const GET_DOCUMENT_DETAILS_FAILURE = 'GET_DOCUMENT_DETAILS_FAILURE';

export const USER_SESSION_REQUEST = 'USER_SESSION_REQUEST';
export const USER_SESSION_SUCCESS = 'USER_SESSION_SUCCESS';
export const USER_SESSION_FAILURE = 'USER_SESSION_FAILURE';
export const USER_SESSION_ANON_FETCHED = 'USER_SESSION_ANON_FETCHED';

export const GET_STUDSUBMISSIONAVAIL_REQUEST = 'GET_STUDSUBMISSIONAVAIL_REQUEST';
export const GET_STUDSUBMISSIONAVAIL_SUCCESS = 'GET_STUDSUBMISSIONAVAIL_SUCCESS';
export const GET_STUDSUBMISSIONAVAIL_FAILURE = 'GET_STUDSUBMISSIONAVAIL_FAILURE';

export const GET_EDITOR_AVAILABLE_TO_EDIT_SUCCESS = 'GET_EDITOR_AVAILABLE_TO_EDIT_SUCCESS';
export const GET_EDITOR_AVAILABLE_TO_EDIT_FAILURE = 'GET_EDITOR_AVAILABLE_TO_EDIT_FAILURE';
export const GET_EDITOR_AVAILABLE_TO_EDIT_REQUEST = 'GET_EDITOR_AVAILABLE_TO_EDIT_REQUEST';
export const GET_COMPLETESUBMISSION_SUCCESS = 'GET_COMPLETESUBMISSION_SUCCESS';

export const GET_ADMIN_DOCUMENTS_FAILURE = 'GET_ADMIN_DOCUMENTS_FAILURE';
export const GET_ADMIN_DOCUMENTS_REQUEST = 'GET_ADMIN_DOCUMENTS_REQUEST';
export const GET_ADMIN_DOCUMENTS_SUCCESS = 'GET_ADMIN_DOCUMENTS_SUCCESS';

export const EDITOR_GET_MY_EDITS_SUCCESS = 'EDITOR_GET_MY_EDITS_SUCCESS';
export const ACCEPT_TO_EDIT_FAILURE = 'ACCEPT_TO_EDIT_FAILURE';
export const ACCEPT_TO_EDIT_SUCCESS = 'ACCEPT_TO_EDIT_SUCCESS';
export const ACCEPT_TO_EDIT_REQUEST = 'ACCEPT_TO_EDIT_REQUEST';

export const EDITOR_CONTACT_INFO_REQUEST = 'EDITOR_CONTACT_INFO_REQUEST';
export const EDITOR_CONTACT_INFO_SUCCESS = 'EDITOR_CONTACT_INFO_SUCCESS';
export const EDITOR_CONTACT_INFO_FAILURE = 'EDITOR_CONTACT_INFO_FAILURE';

export const UPDATE_INVOICE_ARRAY = 'UPDATE_INVOICE_ARRAY';
export const UPDATE_STEP_3_SUMMARY = 'UPDATE_STEP_3_SUMMARY';
// Admin ------------------------------------------------------
export const  GET_ADMINUSERCOLLECTION_REQUEST = 'GET_ADMINUSERCOLLECTION_REQUEST';
export const  GET_ADMINUSERCOLLECTION_SUCCESS = 'GET_ADMINUSERCOLLECTION_SUCCESS';
export const  GET_ADMINUSERCOLLECTION_FAILURE = 'GET_ADMINUSERCOLLECTION_FAILURE';
export const  GET_ADMINSTUDENTCOLLECTION_SUCCESS = 'GET_ADMINSTUDENTCOLLECTION_SUCCESS';
export const  GET_ADMINSTUDENTCOLLECTION_REQUEST = 'GET_ADMINSTUDENTCOLLECTION_REQUEST';
export const  GET_ADMINSTUDENTCOLLECTION_FAILURE = 'GET_ADMINSTUDENTCOLLECTION_FAILURE';
export const  ADMIN_DOCUMENT_LIST_FILTER_STATE = 'ADMIN_DOCUMENT_LIST_FILTER_STATE';

export const ADD_AFFILIATE = 'ADD_AFFILIATE';
export const ADD_COUPON = 'ADD_AFFILIATE';
export const REMOVE_AFFILIATE = 'REMOVE_AFFILIATE';
export const REMOVE_COUPON = 'REMOVE_AFFILIATE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const GET_AFFILIATES_SUCCESS = 'GET_AFFILIATES_SUCCESS';
export const GET_AFFILIATES_REQUEST = 'GET_AFFILIATES_REQUEST';
export const GET_AFFILIATES_FAILURE = 'GET_AFFILIATES_FAILURE';
export const GET_COUPON_SUCCESS = 'GET_COUPONCODES_SUCCESS';
export const GET_COUPON_REQUEST = 'GET_COUPON_REQUEST';
export const GET_COUPON_FAILURE = 'GET_COUPON_FAILURE';

export const GET_COUPONCODES_SUCCESS = 'GET_COUPONCODES_SUCCESS';
export const GET_COUPONCODES_REQUEST = 'GET_COUPONCODES_REQUEST';
export const GET_COUPONCODES_FAILURE = 'GET_COUPONCODES_FAILURE';
// ADmin ------------------------------------------------------



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js